<template>
  <div
    class="cb-multimedia-edit w-full flex items-center justify-center rounded-2 bg-primary6"
    :class="{
      'h-[100px]': !isScribbleChild,
      'h-full': isScribbleChild,
    }"
  >
    <CIcon :color="themeVars.primary4" :icon="ComponentIcon.Multimedia" size="36px" />
  </div>
</template>

<script setup lang="ts">
import CIcon from '@lib/components/CIcon/CIcon.vue'
import useThemeVars from '@lib/composables/useThemeVars'
import { ComponentIcon } from '@canvas-builder/types/canvas'

withDefaults(
  defineProps<{
    isScribbleChild: boolean
  }>(),
  {
    isScribbleChild: false,
  },
)
const themeVars = useThemeVars()
</script>
